<div class="main">
  <app-control #control
               (colorSelected)="onColorSelected($event)"
               (generateClicked)="onGenerateClicked()"
               (downloadClicked)="onDownloadClicked($event)"
               (resetClicked)="onResetClicked()">
  </app-control>
  <app-edit #edit
            (generatePressed)="onGenerateClicked()">
  </app-edit>
  <app-view #view></app-view>
  <app-google-adsense></app-google-adsense>
</div>
